export default "__VITE_ASSET__C_9LWRPE__"